import { render, staticRenderFns } from "./XcxRoles.vue?vue&type=template&id=2a8c4995&scoped=true"
import script from "./XcxRoles.vue?vue&type=script&lang=js"
export * from "./XcxRoles.vue?vue&type=script&lang=js"
import style0 from "./XcxRoles.vue?vue&type=style&index=0&id=2a8c4995&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8c4995",
  null
  
)

export default component.exports